
import { widget } from '../widget-decorator';
import { BindingEngine, customElement, useView, PLATFORM } from 'aurelia-framework';
import { InstrumentValueGroup } from '../../clients/reporting-clients';
import { CustomerService } from '../../services/customer-service';
import { WidgetBase } from '../widget-base';
import { IApplicationFilter } from '../../interfaces/i-application-filter';
import { PortfolioReportCache } from '../../services/portfolio-report-cache';
import { property } from '../property-decorator';

declare module '../../clients/reporting-clients' {
  interface InstrumentValueGroup {
    estimatedProfitLossPercent?: number;
    estimatedValuePercent?: number;
  }
}

@customElement('mandat-widget')
@useView(PLATFORM.moduleName('./mandat-widget.html'))
@widget('Mandat kontroll', true, true)
export class MandatWidget extends WidgetBase {
  constructor(element: Element, customerSettings: CustomerService, bindingEngine: BindingEngine, private portfolioReportCache: PortfolioReportCache) {
    super(element, bindingEngine, customerSettings);
  }

  data: InstrumentValueGroup[];
  filter: IApplicationFilter;
  widgetDiv: HTMLDivElement;

  @property()
  headerFont?: string;

  @property()
  headerFontSize?: number;

  @property()
  headerColor?: string;

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number;

  @property('Text')
  color?: string;

  @property('Style')
  otherThreshold: number = 5;

  override async loadData(filter: IApplicationFilter) {
    this.filter = filter;
    return this.portfolioReportCache.instrumentValueGroupsOverTime(filter.customer.companyId, undefined, filter.dates.fromStr, filter.dates.toStr, false);
  }

  override async setData(data: InstrumentValueGroup[]) {
    data = data.filter(x => x.date >= this.filter.dates.toStr);
    const estimatedValueSum = data.reduce((acc, curr) => acc + curr.estimatedValue, 0);
    data.forEach(x => {
      x.estimatedValuePercent = x.estimatedValue / estimatedValueSum * 100;
    });
    var other = new InstrumentValueGroup({ group: 'Other' });
    other.estimatedValuePercent = data.filter(x => x.estimatedValuePercent < this.otherThreshold).reduce((acc, curr) => acc + curr.estimatedValue, 0) / estimatedValueSum * 100;
    this.data = [...data.filter(x => x.estimatedValuePercent >= this.otherThreshold), other]
      .filter(x => Math.trunc(x.estimatedValuePercent) > 0)
      .sort((a, b) => b.estimatedValue - a.estimatedValue);
  }

  override configChanged(key: string) {
    switch (key) {
      default:
        this.refresh$.next();
        break;
    }
  }
}
